import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { Col, Row, Button } from "react-bootstrap";
import axios from "axios";
import Arrow from "./svg/Arrow";
import { useSelector, useDispatch } from "react-redux";
import useWindowSize from "../../../hooks/useWindowSize";
import { setTitle } from "../../../redux/slices/templateTitleSlice.js";
import { useParams } from "react-router-dom";
import { designTypes } from "../../../constants/common";

const chunkArray = (array, chunkSize) => {
  let result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};

const Templates = () => {
  const [divs, setDivs] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [showAllButtons, setShowAllButtons] = useState(false);
  const [originalDivs, setOriginalDivs] = useState([]);
  const { isDesktop } = useWindowSize();
  const dispatch = useDispatch();
  const titleFromRedux = useSelector((state) => state.titleSlice.title);

  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.landingPages,
  }));

  const templateHeadings = {
    PDF: lang[10],
    Apps: lang[13],
    Business: lang[18],
    Coupon: lang[14],
    Event: lang[16],
    FeedBack: lang[21],
    Images: lang[17],
    "Wi-Fi": lang[22],
    Website: lang[12],
    "List Of Links": lang[11],
    Menu: lang[19],
    MP3: lang[20],
    Playlist: lang[15],
    Video: lang[23],
    vCard: lang[24],
    Pets: lang[25],
    Retail: lang[26],
    Tourism: lang[27],
    "Restaurants and Cafes": lang[28],
    Education: lang[29],
    Medical: lang[30],
    "Government Services": lang[31],
    "Automotive Industry": lang[32],
    "Sports and Fitness": lang[33],
    IT: lang[34],
    Cleaning: lang[35],
    "E commerce": lang[36],
    "Home Services": lang[237],
    Music: lang[38],
    "Energy and Utilities": lang[39],
    "Freelancing and Gig Economy": lang[40],
    Gaming: lang[41],
    "Publishing and Media": lang[42],
    "Personal Care and Beauty": lang[43],
    "Security Services": lang[44],
    "Translation and Language Services": lang[45],
    "Non-Profit Organizations": lang[46],
    Logistics: lang[47],
    "Finance and Banking": lang[48],
    CV: lang[49],
    "Cultural Institution": lang[50],
    "Real Estate": lang[51],
    "Learning and Development": lang[52],
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("/entry/constructor/templates");
        const filteredData = response.data
          .filter((item) =>
            item.pagesSortedByPositionMeQr.some((page) => page.image)
          )
          .filter((item) => item.title !== "Wi-Fi");

        const transformedData = filteredData.map((item, index) => ({
          id: index + 1,
          title: item.title,
          pages: item.pagesSortedByPositionMeQr,
        }));

        setDivs(transformedData);
        setOriginalDivs(transformedData);
        setActiveId(transformedData[0]?.id);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!originalDivs.length) {
      return;
    }
    const urlParamsTitle = new URLSearchParams(window.location.search).get(
      "title"
    );
    if (titleFromRedux || urlParamsTitle) {
      const divToActivate = originalDivs.find(
        (div) => div.title === titleFromRedux || div.title === urlParamsTitle
      );
      if (divToActivate) {
        moveToTop(divToActivate.id);
      }
      dispatch(setTitle(""));
    }
  }, [titleFromRedux, originalDivs, dispatch]);

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    if (hash) {
      const divToActivate = originalDivs.find(
        (div) => div.title.replace(/\s+/g, "") === hash
      );
      if (divToActivate) {
        moveToTop(divToActivate.id);
        window.location.hash = "";
      }
    }
  }, [originalDivs]);
  // useEffect(() => {
  //   const element = document.getElementById('description');
  //   if (element) {
  //     element.remove();
  //   }
  // }, []);
  const moveToTop = (id) => {
    const updatedDivs = originalDivs.filter((div) => div.id !== id);
    const selectedDiv = originalDivs.find((div) => div.id === id);
    if (selectedDiv) {
      setDivs([selectedDiv, ...updatedDivs]);
      setActiveId(id);
    }
  };

  const toggleShowAllButtons = () => {
    setShowAllButtons(!showAllButtons);
  };
  const { id } = useParams();
  const locale = useSelector((state) => state.changeLang.change);
  const designType = useSelector((state) => state.customizeQr.designType);

  const editId = id;

  const handleRedirectClick = (pageId) => {
    const localePrefix = locale !== "en" ? `/${locale}` : "";
    designType === designTypes.art && sessionStorage.setItem("artQr", true);
    if (window.location.href.includes("/edit/template?back=/entry")) {
      window.location.href = `${localePrefix}/entry/constructor/clone/${pageId}/${editId}`;
    } else {
      window.location.href = `${localePrefix}/entry/constructor/clone/${pageId}`;
    }
  };

  const renderCarouselItems = (pages, chunkSize) => {
    const chunks = chunkArray(pages, chunkSize);
    return chunks.map((chunk, index) => (
      <Carousel.Item key={index}>
        <Row className="gx-3">
          {chunk.map((page) => (
            <Col
              key={page.id}
              lg={3}
              xs={6}
              onClick={() => handleRedirectClick(page.id)}
            >
              <div className="d-flex justify-content-center cursor-pointer template-card">
                <img
                  className="cursor-pointer"
                  src={page.image}
                  alt={`Template Card${page.id}`}
                  loading="lazy"
                />
              </div>
            </Col>
          ))}
        </Row>
      </Carousel.Item>
    ));
  };

  return (
    <>
      <Col xs={12} lg={10} className="mx-auto mt-4 pt-2">
        <div className="d-flex justify-content-lg-center mb-lg-4 mb-3 flex-lg-wrap overflow-auto">
          {originalDivs
            .slice(0, isDesktop && !showAllButtons ? 8 : originalDivs.length)
            .map((div) => (
              <Button
                key={div.id}
                className={`btn btn-primary focus-0 border-0 fw-bold me-3 px-3 mb-3 d-flex align-items-center fs-7 template-button ${
                  activeId === div.id ? "active" : ""
                }`}
                onClick={() => moveToTop(div.id)}
                data-title={div.title}
              >
                <svg className="icon me-2" style={{ width: 24, height: 24 }}>
                  <use
                    href={`/static/pages/main-page-img/template-icons.svg?v=23062025#icon-${div.title
                      .toLowerCase()
                      .replaceAll(" ", "")}`}
                  ></use>
                </svg>
                {div.title}
              </Button>
            ))}

          {isDesktop && originalDivs.length > 8 && (
            <Button
              className="btn btn-secondary bg-white text-dark focus-0 border-0 fw-bold me-3 px-2 mb-3"
              onClick={toggleShowAllButtons}
            >
              {showAllButtons ? <Arrow deg={180} /> : <Arrow deg={0} />}
            </Button>
          )}
        </div>
      </Col>
      <div className="bg-white rounded py-5">
        <Col xs={11} md={10} className="mx-auto">
          <h1 className="fs-2 mb-4 text-center">{lang[2]}</h1>
          {divs.map((div) => (
            <div key={div.id} className="pb-5 mb-5 border-bottom">
              <div className="pb-lg-5 pb-3">
                <h2 className="fs-3 mb-4">
                  {templateHeadings[div.title] || div.title}
                </h2>
                <Carousel
                  interval={null}
                  indicators={
                    isDesktop ? div.pages.length > 4 : div.pages.length > 2
                  }
                  controls={
                    isDesktop ? div.pages.length > 4 : div.pages.length > 2
                  }
                >
                  {isDesktop
                    ? renderCarouselItems(div.pages, 4)
                    : renderCarouselItems(div.pages, 2)}
                </Carousel>
              </div>
            </div>
          ))}
        </Col>
      </div>
    </>
  );
};

export default Templates;
